import {Component, Module} from 'app/decorators';

import _ from 'lodash';
import angular from 'angular';

import confirmModalTpl from './confirm.modal.html';
import tpl from './status.button.html';


class ConfirmationModalCtrl {

    constructor ($q, $growl, $uibModalInstance, status, objects, tableCtrl) {
        "ngInject";

        this.$modal = $uibModalInstance;
        this.$q = $q;
        this.$growl = $growl;

        this.status = status;
        this.objects = objects;
        this.tableCtrl = tableCtrl;
        this.loading = false;
    }

    get title () {
        return `Confirm`;
    }

    close () {
        this.$modal.dismiss();
    }

    submit () {
        let self = this;
        self.loading = true;
        self.errors = [];

        let promises = _.map(self.objects, function(obj, idx) {
            let $promise = obj.patch({status: self.status.value});

            return $promise.then(
                (response) => {  // successful
                    angular.extend(obj, response);
                    if (self.tableCtrl) {
                        delete self.tableCtrl.checked[obj.id];
                    }
                },
                (response) => {  // error
                    let errMessage
                    if (response.status === 400) {
                       errMessage = Object.keys(response.data).reduce((result, key, idx) => {
                        return idx === 0 ? response.data[key].join(", ") : result + response.data[key].join(", ")
                       }, "")
                    }
                    if (response.status === 500) {
                        errMessage = response.data.detail
                    }
                    const err = {object: obj, message: errMessage}
                    self.errors.push(err);
                }
            )
        });

        self.$q.all(promises)
            .then(() => {
                if (self.errors.length > 0) { // After click take only with errors
                    self.objects = _.map(self.errors, (o) => o.object);
                    return;
                }
                self.$modal.close(true);
            })
            .finally(() => self.loading=false);
    }
}


@Module({
    name: "app.directives.status.button.component",
})
@Component({
    selector: 'blnd-status-button',
    template: tpl,
    bindings: {
        ngModel: '=',
        ngDisabled: '=?',
        type: "@",
        multiple: "=?",
        table: '<',
    },
})
export default class C {
    constructor ($growl, $element, R, Modal, Config, PermPermissionStore) {
        "ngInject";

        this.$growl = $growl;
        this.$element = $element;

        if (_.indexOf(['order', 'ticket'], this.type) === -1) {
            throw 'Invalid type for statuses';
        }

        this.R = R;
        this.Modal = Modal;

        this.multiple = this.multiple || false;
        this.allStatuses = Config.$config[this.type].statuses;
        this.statuses = this.allStatuses.filter((element) => element[0] === this.$element.status)

        this.limitStatusChoices = () => {
            if (this.type == "order") {
                this.statuses = this.allStatuses
                this.statusMap = _.fromPairs(this.statuses);
                return
            }

            this.statuses = this.allStatuses.filter((element) => element[0] === this.ngModel.status)
            if(this.ngModel.status === "pending" && PermPermissionStore.hasPermissionDefinition("main.can_ticket_status_only_pending_to_ready_to_bill")) {
                this.statuses.push(...this.allStatuses.filter((element) => {
                    return element[0] === "ready_to_bill"
                }))
            }
            if(this.ngModel.status === "mixed" && PermPermissionStore.hasPermissionDefinition("main.can_ticket_status_only_mixed_to_ready_to_bill")) {
                this.statuses.push(...this.allStatuses.filter((element) => {
                    return element[0] === "ready_to_bill"
                }))
            }

            if(PermPermissionStore.hasPermissionDefinition("main.can_change_ticket_status_freely")) {
                this.statuses = this.allStatuses
            } else {
                const currentStatusPair = this.allStatuses.find((status) => status === this.ngModel.status)
                const currentStatusIndex = this.allStatuses.indexOf(currentStatusPair)
                this.statuses = this.statuses.filter((_, index) => index >= currentStatusIndex)
            }
            this.statusMap = _.fromPairs(this.statuses);
        }

        this.limitStatusChoices()
        this.ngDisabled = this.ngDisabled || false;
        this.loading = false;

    }

    $onDestroy () {
        this.$element.remove();
        this.$element = null;
    }

    changeStatus (newStatus) {
        if (this.multiple) {
            this.changeMultipleObjects(newStatus);
            return;
        }
        this.changeSingleObject(newStatus)
    }

    changeSingleObject (newStatus) {
        let self = this;
        self.loading = true;

        let $modal = self.Modal.open({
            template: confirmModalTpl,
            controller: ConfirmationModalCtrl,
            resolve: {
                status: () => {
                    return {
                        value: newStatus,
                        label:  self.getLabel(newStatus)
                    };
                },
                objects: () => [self.ngModel],
                tableCtrl: () => undefined,
            },
        });

        $modal.result.then(function(result){
            if (result) {
                self.limitStatusChoices()
                self.$growl.success('Status Changed!');
            }
        });
        self.loading = false;
    }

    changeMultipleObjects (newStatus) {
        let self = this;
        let $modal = self.Modal.open({
            template: confirmModalTpl,
            controller: ConfirmationModalCtrl,
            resolve: {
                status: () => {
                    return {
                        value: newStatus,
                        label:  self.getLabel(newStatus)
                    };
                },
                objects: () => self.ngModel,
                tableCtrl: () => self.table,
            },
        });

        $modal.result.then(function(result){
            if (result) {
                self.$growl.success('Statuses updated!');
            }
        });
    }

    get label () {
        return this.getLabel(this.ngModel.status);
    }

    getLabel (status) {
        return this.statusMap[status];
    }
}



// WEBPACK FOOTER //
// ./src/app/directives/status.button/component.js